import {camelizeKeys} from 'humps'
import {fetcher, getHeaders, postHeaders} from './fetcher'

export const confirmCybersourcePayment = async ({
  payableType,
  payableId,
  authenticityToken,
  transientToken,
  captureContext,
  payerDetails: {firstName, lastName},
}) => {
  const body = {
    payable_type: payableType,
    payable_id: payableId,
    transient_token: transientToken || '',
    capture_context: captureContext,
    payer_details: {
      first_name: firstName,
      last_name: lastName,
    },
  }
  const opts = postHeaders({authenticityToken, body})

  try {
    const data = await fetcher('/api/credit_cards', opts)

    return camelizeKeys(data, {deep: true})
  } catch (e) {
    // The default error handling in fetcher.js will throw an APINetworkError
    // We want to return the error message for the caller
    return {error: e.message}
  }
}

export const retrieveInvoicePaymentInfo = async ({xeroInvoiceUUID}) => {
  const data = await fetcher(
    `/api/payments/${xeroInvoiceUUID}/payment_info`,
    getHeaders,
  )

  return camelizeKeys(data, {deep: true})
}

export const retrieveInvoicePointsInfo = async ({xeroInvoiceUUID}) => {
  const data = await fetcher(
    `/payments_on_demand/api/invoice_points/${xeroInvoiceUUID}`,
    getHeaders,
  )

  return camelizeKeys(data, {deep: true})
}

export const informPayment = ({
  type,
  amount,
  notes,
  invoiceId,
  authenticityToken,
}) => {
  const body = {
    outside_payment: {
      full_or_partial: type,
      amount,
      notes,
    },
  }
  const opts = postHeaders({authenticityToken, body})

  return fetcher(`/api/invoices/${invoiceId}/inform_payments`, opts)
}

export const createOutsidePayment = ({
  type,
  amount,
  notes,
  invoiceId,
  authenticityToken,
}) => {
  const body = {
    outside_payment: {
      full_or_partial: type,
      amount,
      notes,
    },
  }
  const opts = postHeaders({authenticityToken, body})

  return fetcher(`/api/invoices/${invoiceId}/outside_payments`, opts)
}
